import {APP_PREFIX_PATH} from "../AppConfig";
import React from "react";


export const DosenRoutes = [
    {
        key: 'dosen.jadwal',
        path: `${APP_PREFIX_PATH}/dosen/jadwal`,
        component: React.lazy(() => import('views/dosen-views/jadwal-dosen')),
    },
    {
        key: 'dosen.input.nilai',
        path: `${APP_PREFIX_PATH}/dosen/input-nilai/list`,
        component: React.lazy(() => import('views/dosen-views/input-nilai')),
    },
    {
        key: 'dosen.input.nilai.input',
        path: `${APP_PREFIX_PATH}/dosen/input-nilai/input`,
        component: React.lazy(() => import('views/dosen-views/input-nilai/input')),
    },
    {
        key: 'dosen.input.nilai.input',
        path: `${APP_PREFIX_PATH}/dosen/input-nilai/input/edit`,
        component: React.lazy(() => import('views/dosen-views/input-nilai/input/edit')),
    },


    {
        key: 'dosen.input.nilai.presensi',
        path: `${APP_PREFIX_PATH}/dosen/input-nilai/presensi`,
        component: React.lazy(() => import('views/dosen-views/input-nilai/presensi')),
    },
    {
        key: 'dosen.input.nilai.jurnal',
        path: `${APP_PREFIX_PATH}/dosen/input-nilai/jurnal`,
        component: React.lazy(() => import('views/dosen-views/input-nilai/jurnal')),
    },

    // KRS
    {
        key: 'dosen.krs',
        path: `${APP_PREFIX_PATH}/dosen/krs`,
        component: React.lazy(() => import('views/dosen-views/krs')),
    },
    {
        key: 'dosen.krs.check-krs',
        path: `${APP_PREFIX_PATH}/dosen/krs/check-krs`,
        component: React.lazy(() => import('views/dosen-views/krs/check-krs')),
    },

    // message
    {
        key: 'dosen.message',
        path: `${APP_PREFIX_PATH}/dosen/message/*`,
        component: React.lazy(() => import('views/master-view/message')),
    },
]
